import { ExpenseCategoryCellData } from 'src/components/TransactionsDataGrid/transactionsDataGrid.types'
import { OrganizationIntegrationListModel } from 'src/models/organizationIntegration.models'
import {
  ConnectedPlatformStatus,
  TransactionListModel,
} from 'src/models/transaction.models'
import { UserListModel } from 'src/models/user.models'
import {
  ExpenseCategoryResponse,
  getStampedLabelForExpCat,
} from 'src/queries/organizations/expenseCategories.queries'

export const computeExpenseCategoryCellData = (
  transaction: TransactionListModel,
  expenseCategory: ExpenseCategoryResponse,
  user: UserListModel | undefined,
  activeIntegration: OrganizationIntegrationListModel | undefined,
  translate: (key: string) => string,
  showReconnectedErpExpenseCategoryLabels = false,
): ExpenseCategoryCellData => {
  const syncStatus = transaction.connectedPlatforms?.find(
    (connection) =>
      connection.platform === activeIntegration?.connectedPlatform,
  )?.syncStatus
  const canShowReconnectedErpExpenseCategoryLabels =
    showReconnectedErpExpenseCategoryLabels &&
    syncStatus === ConnectedPlatformStatus.Success

  const matchingExpenseCat = getStampedLabelForExpCat(
    transaction,
    expenseCategory,
    canShowReconnectedErpExpenseCategoryLabels,
  )

  const showMissingWhenEmpty =
    !!user?.hasOrgBookkeeperPermissions &&
    transaction.isCleared &&
    transaction.checkSingleMissingRequiredExpenseCategory(
      expenseCategory,
      activeIntegration?.connectedPlatform,
    )

  const isEmpty =
    transaction?.expenseDetails === undefined ||
    transaction?.expenseDetails?.length === 0

  let valueText = ''
  if (showMissingWhenEmpty) {
    valueText = translate('Missing')
  } else if (!isEmpty && matchingExpenseCat) {
    valueText = matchingExpenseCat.labelName
  }

  const appliedByAutomation =
    !!matchingExpenseCat?.ruleId || !!matchingExpenseCat?.generatedByPrediction

  return {
    valueText,
    labelIdOrFreeText:
      matchingExpenseCat?.labelId ?? matchingExpenseCat?.labelName,
    showMissingWhenEmpty,
    appliedByAutomation,
    generatedByPrediction: matchingExpenseCat?.generatedByPrediction,
    errorMessage: matchingExpenseCat?.errorMessage,
    cellType:
      expenseCategory.freeTextAllowed && !expenseCategory.hasLabels
        ? 'text'
        : 'select',
  }
}

export const canEditExpenseCategory = (params: {
  transaction: TransactionListModel
  activeIntegration: OrganizationIntegrationListModel | undefined
}): boolean => {
  if (params.transaction.isSplit) {
    return false
  }
  const syncStatus = params.transaction.connectedPlatforms?.find(
    (connection) =>
      connection.platform === params.activeIntegration?.connectedPlatform,
  )?.syncStatus

  return (
    syncStatus === undefined ||
    syncStatus === 'FAILED' ||
    syncStatus === 'NOT_SYNCED'
  )
}
